import { getKey, showPaymentPageUrl, isFunction } from '../src/utils/common';
import { isWebViewFlow } from '../../common/src/utils/common';
/* -------------------------------- POLYFILLS ------------------------------ */

const promiseLoadHandler = (function _promiseLoadHandler() {
  let _promiseLoadSubscribers = [];

  function onPromiseResolved() {
    _promiseLoadSubscribers.forEach(cb => cb());
    _promiseLoadSubscribers = [];
  }

  function addPromiseLoadSubscriber(cb) {
    isFunction(cb) && _promiseLoadSubscribers.push(cb);
  }

  return {
    onPromiseResolved,
    addPromiseLoadSubscriber
  };
})();

(function polyfillHandler() {
  function _loadPolyfill(path, next) {
    const s = document.createElement('script');
    s.type = 'application/javascript';
    s.async = true;
    s.src = path;
    s.onload = function onScriptLoad() {
      next && next();
    };
    document.body.appendChild(s);
  }

  // Promise polyfill
  window.Promise ||
    _loadPolyfill(
      'https://staticpg.paytm.in/common/lib/promise/promise-polyfill.min.js',
      promiseLoadHandler.onPromiseResolved
    );

  // String.fromCodePoint polyfill
  // Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/fromCodePoint
  // eslint-disable-next-line
  String.fromCodePoint||function(d){var f=function(g){for(var b=[],a,e="",c=0,h=arguments.length;c!==h;++c){a=+arguments[c];if(!(1114111>a&&a>>>0===a))throw RangeError("Invalid code point: "+a);65535>=a?a=b.push(a):(a-=65536,a=b.push((a>>10)+55296,a%1024+56320));16383<=a&&(e+=d.apply(null,b),b.length=0)}return e+d.apply(null,b)};try{Object.defineProperty(String,"fromCodePoint",{value:f,configurable:!0,writable:!0})}catch(g){String.fromCodePoint=f}}(String.fromCharCode);
  // Number.isNaN poyfill
  // Source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
  // eslint-disable-next-line
  Number.isNaN=Number.isNaN||function(a){return"number"===typeof a&&a!==a};
})();

/* -------------------------------------------------------------------------- */

const _preact = require('preact');

const interopDefault = m => (m && m.default ? m.default : m);

// eslint-disable-next-line import/no-unresolved
let app = interopDefault(require('preact-cli-entrypoint'));

const checkout = require('../src/common/checkout');
const logger = require('../src/common/logger');

if (typeof app === 'function') {
  let _config = {};
  let _renderedAppDataId = '';

  (function loadLogScript() {
    const ele = document.createElement('script');
    if (ele) {
      ele.type = 'application/javascript';
      ele.src = `https://staticpg.paytm.in/common/lib/logger/ui-logger.min.js`;
      ele.async = true;
      ele.crossOrigin = 'anonymous';
      ele.onload = () => {
        logger.init({
          debug: ENV !== 'prod',
          env: `checkoutjs_${ENV}`
        });
      };
      document.body.appendChild(ele);
    }
  })();

  const removeElementById = id => {
    const element = document.getElementById(id);

    if (element) {
      element.remove();
    }
  };

  const element = selector => {
    let ele;
    if (!selector) {
      const elementId = 'paytm-checkoutjs';
      removeElementById(elementId);
      // when merchant doesn't pass the selector
      ele = document.createElement('div');
      ele.id = elementId; // parent element
      ele.setAttribute('class', 'ptm-own-element');
      document.body.appendChild(ele);
    } else if (selector.constructor === String) {
      // merchant has pass the selector
      ele = document.querySelector(selector);
      if (!ele) {
        throw new Error(`selector id ${selector} not exists in the dom`);
      }
    } else if (selector instanceof HTMLElement) {
      ele = selector;
    } else {
      // selector is not a string value
      throw new Error(`selector should be of string or HTMLElement`);
    }
    ele.appendChild(document.createElement('div')); // element in which app is render
    return ele;
  };

  const removeElementByAttribute = (attribute, value) => {
    const element = document.querySelector(`[${attribute}='${value}']`);

    if (element) {
      element.remove();
    }
  };

  const _init = (instanceKey, selector) => {
    const dataIdAttrName = 'data-id';

    if (!selector && _renderedAppDataId) {
      removeElementByAttribute(dataIdAttrName, _renderedAppDataId);
    }
    // eslint-disable-next-line global-require,import/no-unresolved
    app = interopDefault(require('preact-cli-entrypoint'));
    const ele = element(selector || _config.root);

    if (ele) {
      const props = { instanceKey };
      const renderedEl = (0, _preact.render)(
        (0, _preact.h)(app, props),
        ele,
        ele.firstElementChild
      );

      if (renderedEl) {
        _renderedAppDataId = `paytm-checkout-app-${new Date().getTime()}`;
        renderedEl.setAttribute(dataIdAttrName, _renderedAppDataId);
      }
    } else {
      throw new Error('checkout not initialize. Please check root field of merchant configuration');
    }
  };

  if (module.hot) module.hot.accept('preact-cli-entrypoint', _init);
  let _isInitResolved = false;
  let _isInvokeQueued = false;

  const _createElement = (baseConfig, payMode, elementConfig) => {
    const mergedElementConfig = { ...baseConfig };

    if (typeof checkout.helpers.getKey(elementConfig, 'root') !== 'string') {
      return console.error('Please provide root value in config');
    }

    mergedElementConfig.root = elementConfig.root;

    if (checkout.helpers.isObject(elementConfig.style)) {
      mergedElementConfig.style = elementConfig.style;
    }

    const isValidPayMode = Object.keys(checkout.ELEMENT_PAYMODE).some(
      mode => checkout.ELEMENT_PAYMODE[mode].toLowerCase() === (payMode || '').toLowerCase()
    );
    if (!isValidPayMode) {
      return console.error('Invalid paymode');
    }

    let isInvokeQueued = null;
    let isInitialized = false;
    const { init, close, instanceKey } = checkout.createInstance(payMode);
    const invokeFn = _init.bind(this, instanceKey);

    init(mergedElementConfig)
      .then(() => {
        isInvokeQueued && invokeFn(mergedElementConfig.root);
        isInitialized = true;
        isInvokeQueued = false;
      })
      .catch(error => {
        console.error(error.message);
      });

    return {
      invoke: () => {
        if (isInitialized) {
          invokeFn(mergedElementConfig.root);
        } else {
          console.info(
            'Invoke has been queued. It will be automatically called once element initialization is completed!'
          );
          isInvokeQueued = true;
        }
      },
      close
    };
  };

  window.CheckoutJS = {
    init: (config = {}) => {
      const mid = checkout.helpers.getMid();
      const orderId = getKey(config, 'data.orderId', '');
      const txnToken = getKey(config, 'data.token', '');

      // When multipleWindowWebview key is false & webview is there then redirection flow initiated
      if (isWebViewFlow(config)) {
        if (orderId && mid && txnToken) {
          window.location.href = `${showPaymentPageUrl()}?mid=${mid}&orderId=${orderId}&txnToken=${txnToken}&flow=checkout&mode=webview`;
          return Promise.resolve();
        }
      }
      _config = config;
      _isInitResolved = false;

      return checkout.init(config).then(response => {
        _isInitResolved = true;

        if (_isInvokeQueued) {
          this.invoke();
        }

        return response;
      });
    },
    invoke: () => {
      if (!_isInitResolved) {
        _isInvokeQueued = true;
        /* eslint no-console: "off" */
        console.info(
          'Invoke has been queued. It will be automatically called once init is completed! Please do make sure to call init.'
        );
        return;
      }

      _isInvokeQueued = false;
      _init(checkout.BASE_INSTANCE_KEY);
    },
    elements(config) {
      if (!config) {
        return console.error('Please provide config!');
      }

      try {
        checkout.helpers.setMerchantConfig(config, true);
      } catch (error) {
        return console.error(error.message);
      }

      config.merchant = config.merchant || {};
      config.merchant.hidePaytmBranding = true;

      checkout.helpers
        .fetchPaymentOptions({
          token: config.data.token,
          orderId: config.data.orderId,
          tokenType: config.data.tokenType
        })
        .catch(error => {
          console.error(error);
        });

      return {
        createElement: _createElement.bind(null, config)
      };
    },
    close: () => {
      checkout.close();
    },
    initLib: mid => {
      let catchCallback;
      return window.Promise
        ? checkout.initLib(mid)
        : {
            then: (resolve, reject) => {
              promiseLoadHandler.addPromiseLoadSubscriber(() => {
                checkout
                  .initLib(mid)
                  .then(resolve, reject)
                  .catch(error => {
                    catchCallback && catchCallback(error);
                  });
              });
            },
            catch: cb => {
              catchCallback = cb;
            }
          };
    },
    PAYMODE: JSON.parse(JSON.stringify(checkout.PAYMODE)),
    ELEMENT_PAYMODE: JSON.parse(JSON.stringify(checkout.ELEMENT_PAYMODE)),
    FLOW: JSON.parse(JSON.stringify(checkout.FLOW)),
    TOKEN: JSON.parse(JSON.stringify(checkout.TOKEN)),
    DEFERRED_EVENTS: JSON.parse(JSON.stringify(checkout.DEFERRED_EVENTS)),
    NOTIFY_MERCHANT_EVENTS: JSON.parse(JSON.stringify(checkout.NOTIFY_MERCHANT_EVENTS))
  };
}



// WEBPACK FOOTER //
// ../build-config/entry.js